import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'linkify',
    standalone: false
})
export class LinkifyPipe implements PipeTransform {

  transform(text: string) {
    return text.replace(/(https?:\/\/[^\s]+)/g, url => `<a id="parse-link" class="link-white" href="${url}" target="_blank">${url}</a>`);
  }
}
